export function HeroText({ text }: { text: string }) {
  return (
    <div className="block__hero-text py-6 px-3 md:py-12 bg-foreground">
      <h1 className="text-2xl lg:text-4xl font-semibold text-center text-background">{text}</h1>
    </div>
  );
}
